(function () {
  'use strict';

  const ROOT_READY = 'vicsThemeReady';
  const SCROLLED_CLASS = 'vics-is-scrolled';
  const HEADER_COMPACT_CLASS = 'vics-header-condensed';
  function updateHeaderState() {
    const compact = window.scrollY > 72;
    document.body.classList.toggle(SCROLLED_CLASS, compact);
    document.querySelector('#header-component')?.classList.toggle(HEADER_COMPACT_CLASS, compact);
  }

  function init() {
    if (document.documentElement.dataset[ROOT_READY] === 'true') return;
    document.documentElement.dataset[ROOT_READY] = 'true';

    updateHeaderState();

    let scrollFrame = 0;
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          updateHeaderState();
          scrollFrame = 0;
        });
      },
      { passive: true }
    );

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
